/*
 *		Copyright (c) 2011-2016	Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.DataTable')
    .directive('accAdvancedSearch', ['SearchService', 'AdvancedFiltersService', 'template', 'dateFilter', function (SearchService, AdvancedFiltersService, template, dateFilter) {
        return {
            scope: {
                table: '=accAdvancedSearch',
                showOwners: '&?'
            },
            templateUrl: template('nodes/_advanced_search'),
            controller: ['$scope', '$element', function($scope, $element) {
                var scrollingElement = $element.parents('.scroller');
                
                $scope.fileTypes = AdvancedFiltersService.fileTypes;
                $scope.periods = AdvancedFiltersService.periods;
                $scope.owners = AdvancedFiltersService.owners;
                $scope.customPeriod = false;
                
                setAdvancedFilters();
                
                $scope.$on('$destroy', function() {
                    if (!SearchService.searchState.rootSearchString) {
                        AdvancedFiltersService.advancedFiltersState = null;
                    }
                });
                
                $scope.$watch('table.entries', function(nodes) {
                    if ($scope.showOwners && $scope.showOwners() && nodes && !$scope.table.loadingMore) {
                        getOwners(nodes);
                    }
                });
                
                $scope.$watchCollection('table.advancedFilters', function(advancedFilters) {
                    scrollingElement.scrollTop(0);
                    
                    AdvancedFiltersService.advancedFiltersState = advancedFilters;
                    
                    if ($scope.table.filteredEntries && !$scope.table.loadingMore) {
                        SearchService.searchState.numFound = $scope.table.filteredEntries.length;
                        $scope.table.isEmpty = $scope.table.filteredEntries.length < 1;
                    }
                });
                
                $scope.$watchCollection('[calendars.valueFrom, calendars.valueTo]', function(newValues) {
                    if (newValues[0] !== '' && newValues[1] !== '') {
                        var
                            from = new Date(newValues[0]),
                            to = new Date(newValues[1]),
                            periodName = dateFilter(from, 'yyyy-MM-dd') + ' — ' + dateFilter(to, 'yyyy-MM-dd');
                        
                        if (from < to) {
                            $scope.table.advancedFilters.period = {name: periodName, from: from, to: to};
                        }
                    }
                });
                
                $scope.openCalendar = function(calendar, event) {
                    $scope.calendars.openedFrom = calendar && calendar === 'from';
                    $scope.calendars.openedTo = calendar && calendar === 'to';
                    event.preventDefault();
                    event.stopPropagation();
                };
    
                $scope.setFileType = function(type) {
                    $scope.table.advancedFilters.fileType = type;
                };
                
                $scope.setPeriod = function(period) {
                    $scope.calendars.valueFrom = '';
                    $scope.calendars.valueTo = '';
                    $scope.table.advancedFilters.period = period;
                };
                
                $scope.setOwner = function(owner) {
                    $scope.table.advancedFilters.owner = owner;
                };
    
                $scope.setContentSearch = function(isContentSearch) {
                    if ($scope.table.advancedFilters.contentSearch != isContentSearch) {
                        $scope.table.advancedFilters.contentSearch = isContentSearch;
                        $scope.table.filters['content_search'] = isContentSearch;
                        $scope.table.reload();
                    }
                };
    
                $scope.toggled = function(open) {
                    if (!open) {
                        $scope.customPeriod = false;
                    }
                };
                
                function setAdvancedFilters() {
                    if (AdvancedFiltersService.advancedFiltersState) {
                        $scope.table.advancedFilters = AdvancedFiltersService.advancedFiltersState;
                    } else {
                        $scope.table.advancedFilters = {
                            fileType: $scope.fileTypes[0],
                            period: $scope.periods[0],
                            owner: $scope.owners[0],
                            contentSearch: false
                        };
                    }
                }
                
                function getOwners(nodes) {
                    var uniqueEmails = [];
    
                    $scope.owners = $scope.owners.slice(0, 1); // leave only the 'Any owner' item
    
                    for (var i = 0; i < nodes.length; i++) {
                        if (uniqueEmails.indexOf(nodes[i]['owner']['email']) === -1) {
                            uniqueEmails.push(nodes[i]['owner']['email']);
                            $scope.owners.push({name: nodes[i]['owner']['name'], email: nodes[i]['owner']['email']});
                        }
                    }
                }
            }],
            link: {
                pre: function preLink($scope) {
                    $scope.dateOptions = {
                        showWeeks: false,
                        startingDay: 1
                    };
    
                    $scope.calendars = {
                        openedFrom: false,
                        valueFrom: '',
                        openedTo: false,
                        valueTo: ''
                    };
                }
            }
        };
    }]);
